import React, { createContext, useState, useCallback } from 'react';

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [currentPage, setCurrentPage] = useState('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  const openEnquiry = useCallback(() => setIsEnquiryOpen(true), []);
  const closeEnquiry = useCallback(() => setIsEnquiryOpen(false), []);

  const updateCurrentPage = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  }, [isMobileMenuOpen]);

  const closeMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  const updateScrollProgress = useCallback((progress) => {
    setScrollProgress(progress);
  }, []);

  const value = {
    currentPage,
    updateCurrentPage,
    isMobileMenuOpen,
    toggleMobileMenu,
    closeMobileMenu,
    scrollProgress,
    updateScrollProgress,
    isEnquiryOpen,
    openEnquiry,
    closeEnquiry
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
